import React, { useState } from "react";
import { Popover, Box, Typography } from "@mui/material";
import { getFaceImage } from "./sentimentScale";

/**
 * Item-level sentiment score, shown as a smiley face (one.png..five.png)
 * on the -3..+3 scale. Click reveals the actual numeric score and its
 * explanation in a popover.
 */
export default function SentimentFace({ score, explanation, size = 34 }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const faceImage = getFaceImage(score);
  const hasScore = score !== null && score !== undefined && !Number.isNaN(score);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Box
        component="img"
        src={faceImage}
        alt={hasScore ? `Sentiment score ${score}` : "Not yet scored"}
        onClick={handleClick}
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          cursor: "pointer",
          "&:hover": { boxShadow: "0 0 0 2px rgba(0,0,0,0.1)" },
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 1.75, maxWidth: 260, bgcolor: "#1a2027", color: "#fff" }}>
          <Typography sx={{ fontSize: 12.5, fontWeight: 700, mb: 0.5 }}>
            Score: {hasScore ? (score > 0 ? `+${score}` : score) : "Not yet scored"}
          </Typography>
          <Typography sx={{ fontSize: 12, lineHeight: 1.5, color: "#d0d7e2" }}>
            {explanation || "No explanation available for this item."}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
